import { setDifficultyLevel } from '../../redux/Slices/InterviewSlice';
import { useAppDispatch, useAppSelector } from '../../redux/store/hooks';

const ChooseDifficultyLevel = () => {
  const dispatch = useAppDispatch();
  const { difficultyLevel } = useAppSelector(state => state.root.interview);

  const difficulties = [
    {
      id: 'BEGINNER',
      label: 'Beginner',
      description: 'Basic concepts and fundamentals',
      color: 'text-green-600'
    },
    {
      id: 'INTERMEDIATE',
      label: 'Intermediate',
      description: 'Moderate complexity problems',
      color: 'text-yellow-600'
    },
    {
      id: 'ADVANCED',
      label: 'Advanced',
      description: 'Complex scenarios and optimization',
      color: 'text-red-600'
    }
  ];
  return (
    <div className='w-full max-w-4xl rounded-lg border border-gray-200 bg-white p-6'>
      <h2 className='mb-4 text-lg font-medium text-gray-700'>
        Select Difficulty Level
      </h2>
      <div className='grid grid-cols-1 gap-4 md:grid-cols-3'>
        {difficulties.map(difficulty => (
          <label key={difficulty.id} className='cursor-pointer'>
            <input
              type='radio'
              name='difficulty'
              value={difficulty.id}
              checked={difficultyLevel === difficulty.id}
              onChange={e => dispatch(setDifficultyLevel(e.target.value))}
              className='hidden'
            />
            <div
              className={`rounded-lg border-2 p-4 transition-all duration-200 ${
                difficultyLevel === difficulty.id
                  ? 'border-blue-400 bg-blue-50'
                  : 'border-gray-200 bg-white hover:border-gray-300'
              }`}
            >
              <div className='mb-2 flex items-center'>
                <div
                  className={`mr-3 h-4 w-4 rounded-full border-2 ${
                    difficultyLevel === difficulty.id
                      ? 'border-blue-400 bg-blue-400'
                      : 'border-gray-300'
                  }`}
                >
                  {difficultyLevel === difficulty.id && (
                    <div className='h-full w-full scale-50 rounded-full bg-white'></div>
                  )}
                </div>
                <span className={`text-sm font-medium ${difficulty.color}`}>
                  {difficulty.label}
                </span>
              </div>
              <div className='ml-7 text-xs text-gray-500'>
                {difficulty.description}
              </div>
            </div>
          </label>
        ))}
      </div>
    </div>
  );
};

export default ChooseDifficultyLevel;
